import React from 'react'

const PopUp = () => {
  return (
    <>

      {/* PopUp */}

      <div className="container" style={{ marginTop: "20px" }}>
        <div className="row">
          <div className="col-md-12">
            <div className="modal" id="mypopUpForm">
              <div className="modal-dialog">
                <div className="modal-content">
                  <div className="modal-header" style={{ marginTop: "30px" }}>
                    <h5 style={{ color: '#000' }}>
                      {/* <i className="fa fa-desktop"> </i> &nbsp;Important Notice from */}
                      {/* <i className="fa fa-hospital" style={{ color: "red" }}> </i> */}
                      <img className='' src="assets/img/giphy.gif" alt style={{ height: "40px", width: "40px" }} />
                      <span style={{ color: '#0f903f' }}> Welcome to Satna Swastik Hospital !</span>
                      <img className='' src="assets/img/giphy.gif" alt style={{ height: "40px", width: "40px" }} />

                    </h5>
                    <button style={{ color: "#0f903f" }} className="close" data-dismiss="modal"><b style={{ color: "#0f903f" }}>X</b></button>
                  </div>
                  <div className="modal-body">
                    <p style={{ color: "#0f903f" }}><b>सभी प्रमुख हेल्थ इंश्योरेंस कंपनियों और थर्ड पार्टी एडमिनिस्ट्रेटर (TPA) के ज़रिए कैशलेस इलाज की सुविधा उपलब्ध है।</b></p>

                    <section id="features" className="features">
                      <div className="" data-aos="fade-up">
                        <div className="row">

                          <div className="col-lg-12" data-aos="fade-left" data-aos-delay={100}>
                            {/* <b style={{ textAlign: "center", color: "#0f903f", fontSize: "20px" }}>Now Available !</b>
                            <p><b>Time:-</b> 10 AM to 02 PM</p> */}
                            {/* <img src="assets/img/now available.png" alt style={{height:"200px", width:"220px"}}/> */}
                            {/* <img src="assets/img/now available.gif" alt  style={{height:"40px", width:"120px"}}/> */}
                            <br />
                            <br />
                            {/* <p>It has come to our attention that some third-party entities are promoting Green Ville Projects' ventures under different investment plans, including fractional ownership and other schemes.</p> */}

                            <img className='' src="https://res.cloudinary.com/dnquglkeh/image/upload/v1774571218/PopUp_cn3nin.webp" alt style={{ marginTop: "-50px" }} />
                            {/* <div className="icon-box mt-2 mt-lg-0" data-aos="zoom-in" data-aos-delay={150}>
                                  <i className="bx bx-receipt" />
                                  <p>⚠️ We want to clarify that Green Ville Projects PVT Ltd has NOT partnered with any company or individual for such promotions.</p>
                                </div>
                                <div className="icon-box mt-2" data-aos="zoom-in" data-aos-delay={150}>
                                  <i className="bx bx-cube-alt" />
                                  <p>✅ Our projects and investment options are handled exclusively by Green Ville Projects, and we take NO responsibility for any misleading claims made by unauthorized sources.</p>
                                </div>
                                <div className="icon-box mt-2" data-aos="zoom-in" data-aos-delay={150}>
                                  <i className="bx bx-images" />
                                  <p>💬 For genuine and verified information, always reach out to us directly through our official communication channels.</p>
                                </div> */}

                          </div>
                        </div>
                        <div className="icon-box" data-aos="zoom-in" data-aos-delay={150}>
                          <i className="bx bx-shield" />
                          <p>📞 Contact us at:  <a href="tel:+91 7509182172"><b> +91 7509182172, 7672326319 </b> </a></p>
                          {/* <p><a href="tel:+91 7509182172"><b>  +91 7509182172 </b> </a></p> */}
                          <p>🌐 Website: <a href='https://satnaswastikhospital.in/' target="_blank"> <b>https://satnaswastikhospital.in</b></a></p>
                        </div>

                        <br />
                        <h5 style={{ color: '#000' }}><i className=""> </i> &nbsp;
                          <span style={{ color: '#0f903f' }}> बड़े शहरों जैसी स्वास्थ्य सुविधा अब  सतना शहर में.</span></h5>

                      </div>
                    </section>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>


    </>
  )
}

export default PopUp